"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function Label(props) {
  var label = props.label,
      value = props.value,
      icon = props.icon,
      iconPosition = props.iconPosition,
      iconWarning = props.iconWarning,
      size = props.size,
      variant = props.variant,
      sizeValue = props.sizeValue,
      onClick = props.onClick,
      fullWidth = props.fullWidth;
  var Icon = icon;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "content-label label-".concat(variant, " ").concat(fullWidth && 'full-width')
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label-title label-title-".concat(size)
  }, label), /*#__PURE__*/_react.default.createElement("span", {
    className: "label-subtitle label-sub-".concat(sizeValue ? sizeValue : size)
  }, icon && iconPosition === 'left' && /*#__PURE__*/_react.default.createElement("div", {
    className: "mr-1 d-flex"
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    style: {
      marginRight: '5px',
      color: "".concat(iconWarning ? '#ff973d' : '')
    }
  })), onClick ? /*#__PURE__*/_react.default.createElement("button", {
    className: "label-button",
    type: "button",
    name: "buttonLabel",
    onClick: onClick
  }, value) : /*#__PURE__*/_react.default.createElement("strong", {
    style: {
      color: "".concat(iconWarning ? '#ff973d' : '')
    }
  }, value), icon && iconPosition === 'right' && /*#__PURE__*/_react.default.createElement("div", {
    className: "ml-1 d-flex"
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    style: {
      marginLeft: '5px',
      color: "".concat(iconWarning ? '#ff973d' : '')
    }
  }))));
};

Label.propTypes = {
  label: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  icon: _propTypes.default.any,
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  iconWarning: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['lg', 'md', 'sm', 'xl']),
  variant: _propTypes.default.oneOf(['outline', 'light', 'fill']),
  sizeValue: _propTypes.default.oneOf(['lg', 'md', 'sm', 'xl']),
  onClick: _propTypes.default.func,
  fullWidth: _propTypes.default.bool
};
Label.defaultProps = {
  label: '',
  value: '',
  icon: null,
  iconPosition: 'left',
  iconWarning: false,
  size: 'md',
  variant: 'light',
  sizeValue: null,
  onClick: null,
  fullWidth: false
};
var _default = Label;
exports.default = _default;